import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";

export default function Register() {
  const { user, register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [busy, setBusy] = useState(false);

  if (user && user !== false && user !== null) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError(null); setBusy(true);
    try {
      await register(email, password, name);
      nav("/onboarding", { replace: true });
    } catch (err) {
      setError(err.userMessage || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-background">
      <div className="flex items-center justify-center p-6 lg:p-12">
        <div className="w-full max-w-md">
          <div className="flex items-center gap-2.5 mb-10">
            <div className="w-9 h-9 rounded-md bg-foreground text-background grid place-items-center font-heading font-bold">D</div>
            <div>
              <div className="font-heading font-semibold leading-tight">Dreamhouse</div>
              <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Flow</div>
            </div>
          </div>
          <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight">Create your account.</h1>
          <p className="text-muted-foreground mt-2 text-sm">Set up your first home in under a minute.</p>

          <form onSubmit={submit} className="mt-8 space-y-4" data-testid="register-form">
            <div>
              <label className="label-tiny block mb-1.5">Name</label>
              <input value={name} onChange={(e) => setName(e.target.value)}
                data-testid="register-name"
                className="w-full px-3 py-2.5 rounded-md bg-zinc-950 border border-border focus:border-zinc-500 outline-none text-sm" />
            </div>
            <div>
              <label className="label-tiny block mb-1.5">Email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                data-testid="register-email"
                className="w-full px-3 py-2.5 rounded-md bg-zinc-950 border border-border focus:border-zinc-500 outline-none text-sm" />
            </div>
            <div>
              <label className="label-tiny block mb-1.5">Password</label>
              <input type="password" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)}
                data-testid="register-password"
                className="w-full px-3 py-2.5 rounded-md bg-zinc-950 border border-border focus:border-zinc-500 outline-none text-sm" />
              <p className="text-[10px] text-muted-foreground mt-1">8 characters minimum.</p>
            </div>
            {error && <div className="text-xs text-[#EF4444] bg-[#EF4444]/10 border border-[#EF4444]/20 rounded-md p-2.5" data-testid="register-error">{error}</div>}
            <button type="submit" disabled={busy}
              className="w-full py-2.5 rounded-md bg-foreground text-background font-medium text-sm hover:bg-zinc-200 disabled:opacity-50"
              data-testid="register-submit">
              {busy ? "Creating…" : "Create account"}
            </button>
            <p className="text-xs text-muted-foreground text-center pt-2">
              Already a member? <Link to="/login" className="text-foreground underline underline-offset-2">Sign in</Link>
            </p>
          </form>
        </div>
      </div>
      <div className="hidden lg:block bg-cover bg-center"
        style={{ backgroundImage: "url(https://static.prod-images.emergentagent.com/jobs/baf1959c-448b-42d0-a6ba-e254d37dd6a6/images/3a57008b0888605369a37529259b72e5b64a3911642763c0a075388fd680c4c0.png)" }}>
        <div className="h-full bg-gradient-to-tr from-black/60 via-black/30 to-transparent" />
      </div>
    </div>
  );
}
